export default "/images/6c82f85256287e6914ec9a0ccef69332.jpg";